'use strict';

import '../../../assets/scripts/boomerang/boomerang';
import '../../../assets/scripts/boomerang/plugins/bw';
import networkTestTemplate from './networkTest.html'

var networkTestController = function ($controller, $translate, $interval, $q, $location, configService, loggingService) {
    var vm = this;

    //controller state
    vm.isFail = false;
    vm.networkTestLine1 = null;
    vm.networkTestLine2 = null;
    vm.networkTestLine3 = null;
    vm.dataCenter = null;
    vm.dataCenterBaseUrl = null;
    vm.beaconReady = null;
    vm.numberOfAttempts = null;
    vm.minBandwidth = null;
    vm.avgBandwidth = null;
    vm.maxLatency = null;
    vm.avgLatency = null;
    vm.interval = null;

    angular.extend(vm, $controller('baseStepController'));

    vm.$onInit = function () {
        vm.initialTranslation();

        vm.initializeStep(vm.$stateParams).then(function (executionStep) {
            vm.executionStep = executionStep;
            vm.startBoomerang();
        });
    }

    vm.getBoomerangParameters = function () {
        var params = vm.executionStep.ticketStep.parameters;
        vm.numberOfAttempts = parseInt(params['numberOfAttempts']) || 5;
        vm.minBandwidth = parseInt(params['minBandwidth']);
        vm.maxLatency = parseInt(params['maxLatency']);
    }

    vm.startBoomerang = function () {
        vm.getBoomerangParameters();

        configService.getDataCenter(vm.executionStep.ticketStep.ticketId)
            .then(function (dataCenter) {
                vm.dataCenter = dataCenter.provider;
                vm.dataCenterBaseUrl = dataCenter.networkTestUrl;
                vm.runBoomerang();
                vm.interval = $interval(vm.onInterval, 1000);
            });
    }

    vm.onInterval = function () {
        if (!vm.beaconReady) return;

        $interval.cancel(vm.interval);
        var errorMessage = '[Network Test FAIL]';
        var isError = false;

        if (vm.minBandwidth && vm.avgBandwidth < vm.minBandwidth) {
            errorMessage = errorMessage + ' Average bandwidth: ' + vm.avgBandwidth + ' (required min bandwidth = ' + vm.minBandwidth + ' bits/sec).';
            isError = true;
        }

        if (vm.maxLatency && vm.avgLatency > vm.maxLatency) {
            errorMessage = errorMessage + ' Average latency: ' + vm.avgLatency + ' (required max latency = ' + vm.maxLatency + ' ms).';
            isError = true;
        }

        if (isError) {
            vm.error(new Error(errorMessage), false);
            vm.isFail = true;
            vm.failureTranslation();
        } else {
            vm.transition();
        }
    }

    vm.runBoomerang = function () {
        vm.deleteCookie('BA');

        BOOMR.init({
            BW: {
                base_url: vm.dataCenterBaseUrl,
                block_beacon: true,
                timeout: 60 * 1000,
                nruns: vm.numberOfAttempts,
                test_https: true
            }
        });

        BOOMR.subscribe('before_beacon', function (o) {
            vm.beaconReady = true;
            vm.avgBandwidth = o.bw;
            vm.avgLatency = o.lat;
            vm.logBoomerangResults(o);
        });
    }

    vm.logBoomerangResults = function (o) {
        var bw_time_date = new Date(0);
        bw_time_date.setUTCSeconds(o.bw_time);
        var ticketStep = vm.executionStep.ticketStep;

        angular.extend(o, {
            bw_time: bw_time_date.toISOString(),
            dataCenter: vm.dataCenter,
            ticketStepId: ticketStep.id,
            studyId: ticketStep.studyId,
            ticketId: ticketStep.ticketId,
            stepId: ticketStep.stepId
        });

        loggingService.info('Boomerang log', o);
    }

    vm.deleteCookie = function (name) {
        document.cookie = name + '=;Path=/;domain=' + $location.host() + ';expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        document.cookie = name + '=;Path=/;domain=.shoppermx.com;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        document.cookie = name + '=;Path=/;domain=shoppermx.com;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    };

    vm.initialTranslation = function () {
        $translate(['networkTest.networkTestLine1', 'general.emptyLine', 'general.thankYou'])
            .then(function (translations) {
                vm.networkTestLine1 = translations['networkTest.networkTestLine1'];
                vm.networkTestLine2 = translations['general.emptyLine'];
                vm.networkTestLine3 = translations['general.thankYou'];
            });
    }

    vm.failureTranslation = function () {
        $translate(['networkTestFail.networkTestFailLine1', 'networkTestFail.networkTestFailLine2', 'general.thankYou']).then(function (translations) {
            vm.networkTestLine1 = translations['networkTestFail.networkTestFailLine1'];
            vm.networkTestLine2 = translations['networkTestFail.networkTestFailLine2'];
            vm.networkTestLine3 = translations['general.thankYou'];
        });
    }
};

networkTestController.$inject = ['$controller', '$translate', '$interval', '$q', '$location', 'configService', 'loggingService'];

export var networkTestComponent = {
    name: 'networkTest',
    template: networkTestTemplate,
    controller: networkTestController,
    controllerAs: 'vm',
    bindings: {
        $stateParams: '<'
    }
};

export var networkTestRoute = {
    name: 'networkTest',
    url: '/networkTest',
    component: 'networkTest'
}